(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ingredient-details-carousel"] && !Shopify.designMode) return;
  try {
    
  function initIngredientCardsCarousel(scope) {
    // Ogni sezione "Ingredient cards"
    var sections = scope.querySelectorAll
      ? scope.querySelectorAll('.ingredient-cards')
      : [];

    sections.forEach(function (section) {
      var list = section.querySelector('.ingredient-cards__list');
      if (!list) return;

      var item = list.querySelector('.ingredient-cards__item');
      if (!item) return;

      var prev = section.querySelector('.ingredient-cards__arrow--prev');
      var next = section.querySelector('.ingredient-cards__arrow--next');

      // Se non ci sono frecce (perché disattivate o poche card), esco
      if (!prev && !next) return;

      function getGap() {
        var style = window.getComputedStyle(list);
        var gap = style.columnGap || style.gap || '0';
        return parseFloat(gap) || 0;
      }

      function getStep() {
        var itemWidth = item.offsetWidth;
        return itemWidth + getGap();
      }

      function scrollByStep(direction) {
        var step = getStep();
        list.scrollBy({ left: step * direction, behavior: 'smooth' });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          scrollByStep(-1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          scrollByStep(1);
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initIngredientCardsCarousel(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initIngredientCardsCarousel(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initIngredientsCarousel(root) {
      // root = .section-wrapper.ingredients-carousel-wrapper
      var slider = root.querySelector('.ingredients-carousel__slider');
      if (!slider) return;

      var list = slider.querySelector('.ingredients-carousel__list');
      var controls = root.querySelector('.ingredients-carousel__heading-container__controls');

      if (!list || !controls) return;

      var prevBtn = controls.querySelector('.ingredient-cards__arrow--prev');
      var nextBtn = controls.querySelector('.ingredient-cards__arrow--next');

      if (!prevBtn || !nextBtn) return;

      function getStep() {
        var visibleDesktop = parseInt(slider.dataset.visibleDesktop || '5', 10);
        var visibleMobile = parseInt(slider.dataset.visibleMobile || '2', 10);
        var visible = window.innerWidth >= 750 ? visibleDesktop : visibleMobile;
        if (visible <= 0) visible = 1;

        // larghezza di una card + gap
        var item = list.querySelector('.ingredients-carousel__item');
        if (!item) return list.clientWidth / visible;

        var itemWidth = item.offsetWidth;
        var style = window.getComputedStyle(list);
        var gap = parseFloat(style.columnGap || style.gap || '0') || 0;

        return itemWidth + gap;
      }

      function scrollList(direction) {
        var step = getStep();
        list.scrollBy({
          left: direction * step,
          behavior: 'smooth'
        });
      }

      prevBtn.addEventListener('click', function () {
        scrollList(-1);
      });

      nextBtn.addEventListener('click', function () {
        scrollList(1);
      });
    }

    function initOnRoot(root) {
      if (!root) return;
      var sections = root.querySelectorAll('.section-wrapper.ingredients-carousel-wrapper');
      sections.forEach(function (section) {
        // evita doppia inizializzazione
        if (section.dataset.ingredientsCarouselInit === 'true') return;
        section.dataset.ingredientsCarouselInit = 'true';
        initIngredientsCarousel(section);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      initOnRoot(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      initOnRoot(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-routine-step"] && !Shopify.designMode) return;
  try {
    
    function initRoutineSection(root) {
      var containers = root.querySelectorAll('[data-routine]');
      if (!containers.length) return;

      containers.forEach(function (container) {
        if (container.dataset.routineInitialized === 'true') return;
        container.dataset.routineInitialized = 'true';

        var currentTitle = container.dataset.currentStepTitle;
        var steps = Array.from(container.querySelectorAll('.routine-step'));
        var panels = Array.from(container.querySelectorAll('.routine-step__panel'));
        var imageEl = container.closest('section').querySelector('[data-routine-image]');

        function isDisabledStep(btn) {
          return btn.classList.contains('routine-step--disabled');
        }

        function activateByTitle(title) {
          if (!title) return;

          steps.forEach(function (btn) {
            var stepTitle = btn.dataset.stepTitle;
            var active = stepTitle === title && !isDisabledStep(btn);
            btn.classList.toggle('routine-step--active', active);

            if (active && imageEl && btn.dataset.stepImage) {
              imageEl.src = btn.dataset.stepImage;
              var label = btn.querySelector('.routine-step__title');
              if (label) {
                imageEl.alt = label.textContent.trim();
              }
            }
          });

          panels.forEach(function (panel) {
            var panelTitle = panel.dataset.stepTitle;
            var disabled = panel.classList.contains('routine-step__panel--disabled');
            panel.hidden = panelTitle !== title || disabled;
          });
        }

        function getFirstEnabledTitle() {
          for (var i = 0; i < steps.length; i++) {
            if (!isDisabledStep(steps[i])) {
              return steps[i].dataset.stepTitle;
            }
          }
          return null;
        }

        // Step iniziale: se quello da metafield è disabilitato o mancante,
        // usiamo il primo enabled.
        var initialTitle = null;

        if (currentTitle) {
          var hasValidCurrent = steps.some(function (btn) {
            return (
              btn.dataset.stepTitle === currentTitle &&
              !isDisabledStep(btn)
            );
          });

          if (hasValidCurrent) {
            initialTitle = currentTitle;
          }
        }

        if (!initialTitle) {
          initialTitle = getFirstEnabledTitle();
        }

        if (initialTitle) {
          activateByTitle(initialTitle);
        }

        container.addEventListener('click', function (event) {
          var trigger = event.target.closest('.routine-step');
          if (!trigger || isDisabledStep(trigger)) return;
          activateByTitle(trigger.dataset.stepTitle);
        });
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      initRoutineSection(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      initRoutineSection(event.target);
    });
  
  } catch(e) { console.error(e); }
})();
})();
